import { render, staticRenderFns } from "./VuesticPageNotFoundLargeText.vue?vue&type=template&id=dcf90df4"
import script from "./VuesticPageNotFoundLargeText.vue?vue&type=script&lang=js"
export * from "./VuesticPageNotFoundLargeText.vue?vue&type=script&lang=js"
import style0 from "./VuesticPageNotFoundLargeText.vue?vue&type=style&index=0&id=dcf90df4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports